import { Expose } from "class-transformer";
import { observable } from "mobx";
import SupplyPointListItem from "./supplyPointListItem";

export default class EtsSupplyPointListItem extends SupplyPointListItem {
  @observable
  @Expose({ name: "ets_years" })
  etsYears: { [key: string]: boolean };

  get availableEtsYears(): string[] {
    return Object.keys(this.etsYears || {});
  }
}
